export function loadPercentage(nodes) {
  nodes.forEach(function (element, index) {
    let percent = element.dataset.percentage + "%";

    element.style.width = percent;
  });
}

export function findAncestor(el, cls) {
  while ((el = el.parentElement) && !el.classList.contains(cls));
  return el;
}

/* SLIDE UP */
export const slideUp = (target, duration = 500) => {
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.boxSizing = "border-box";
  target.style.height = target.offsetHeight + "px";
  target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  window.setTimeout(() => {
    target.style.display = "none";
    target.style.removeProperty("height");
    target.style.removeProperty("padding-top");
    target.style.removeProperty("padding-bottom");
    target.style.removeProperty("margin-top");
    target.style.removeProperty("margin-bottom");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
    //alert("!");
  }, duration);
};

/* SLIDE DOWN */
export const slideDown = (target, duration = 500) => {
  target.style.removeProperty("display");
  let display = window.getComputedStyle(target).display;
  if (display === "none") display = "block";
  target.style.display = display;
  let height = target.offsetHeight;
  target.style.overflow = "hidden";
  target.style.height = 0;
  target.style.paddingTop = 0;
  target.style.paddingBottom = 0;
  target.style.marginTop = 0;
  target.style.marginBottom = 0;
  target.offsetHeight;
  target.style.boxSizing = "border-box";
  target.style.transitionProperty = "height, margin, padding";
  target.style.transitionDuration = duration + "ms";
  target.style.height = height + "px";
  target.style.removeProperty("padding-top");
  target.style.removeProperty("padding-bottom");
  target.style.removeProperty("margin-top");
  target.style.removeProperty("margin-bottom");
  window.setTimeout(() => {
    target.style.removeProperty("height");
    target.style.removeProperty("overflow");
    target.style.removeProperty("transition-duration");
    target.style.removeProperty("transition-property");
  }, duration);
};

export function isWebp() {
  // Проверка поддержки webp
  function testWebp(callback) {
    let webP = new Image();
    webP.onload = webP.onerror = function () {
      callback(webP.height == 2);
    };
    webP.src =
      "data:image/webp;base64,UklGRjoAAABXRUJQVlA4IC4AAACyAgCdASoCAAIALmk0mk0iIiIiIgBoSygABc6WWgAA/veff/0PP8bA//LwYAAA";
  }
  // Добавление класса _webp или _no-webp для HTML
  testWebp(function (support) {
    let className = support === true ? "webp" : "no-webp";
    document.documentElement.classList.add(className);
  });
}

// Cookie
// возвращает куки с указанным name,
// или undefined, если ничего не найдено
export function getCookie(name) {
  let matches = document.cookie.match(
    new RegExp(
      "(?:^|; )" +
        name.replace(/([\.$?*|{}\(\)\[\]\\\/\+^])/g, "\\$1") +
        "=([^;]*)"
    )
  );
  return matches ? decodeURIComponent(matches[1]) : undefined;
}

export function setCookie(name, value, options = {}) {
  options = {
    path: "/",
    // при необходимости добавьте другие значения по умолчанию
    ...options,
  };

  if (options.expires instanceof Date) {
    options.expires = options.expires.toUTCString();
  }

  let updatedCookie =
    encodeURIComponent(name) + "=" + encodeURIComponent(value);

  for (let optionKey in options) {
    updatedCookie += "; " + optionKey;
    let optionValue = options[optionKey];
    if (optionValue !== true) {
      updatedCookie += "=" + optionValue;
    }
  }

  document.cookie = updatedCookie;
}

export function deleteCookie(name) {
  setCookie(name, "", {
    "max-age": -1,
  });
}

export function declension(
  oneNominative,
  severalGenitive,
  severalNominative,
  number
) {
  number = number % 100;

  return number <= 14 && number >= 11
    ? severalGenitive
    : (number %= 10) < 5
    ? number > 2
      ? severalNominative
      : number === 1
      ? oneNominative
      : number === 0
      ? severalGenitive
      : severalNominative //number === 2
    : severalGenitive;
}

// инициализирует кнопку "получить бонус на детальной букмекера"
export function initGetBonusMobileBtn() {
  if ($(window).width() < 1200) {
    const headerBkRight = $(".header__bk__right");
    if (headerBkRight.length) {
      const mainPopup = $(".main__popup");
      const mainPopupHeight = mainPopup.outerHeight();
      let btnBottomOffset = 15;
      const bottom = btnBottomOffset + mainPopupHeight + "px";
      headerBkRight.css("bottom", bottom);
    }
  }
}

// инициализирует высоту отспупа снизу у нижних кнопок
export function buttomBtnInit() {
  const upBtn = $("#upBtn");
  const spinnerStart = $(".spinner-start");
  const mainPopup = $(".main__popup");
  const mainPopupHeight = mainPopup.outerHeight();

  let btnBottomOffset = 25;
  let bottom;

  if ($(window).width() < 1200) {
    btnBottomOffset = 15;
    bottom = btnBottomOffset + mainPopupHeight + "px";

    const bkIntroBtn = $(".bk__intro__btn ");

    if (bkIntroBtn.length) {
      const bkIntroBtnHeight = bkIntroBtn.outerHeight();
      bottom =
        btnBottomOffset +
        btnBottomOffset +
        bkIntroBtnHeight +
        mainPopupHeight +
        "px";
    }
  } else {
    const cookies = $(".cookies");
    let cookiesHeight;

    if (cookies.length) {
      cookiesHeight = cookies.outerHeight();
      bottom = btnBottomOffset + cookiesHeight + "px";
    } else {
      bottom = btnBottomOffset + "px";
    }
  }

  upBtn.css("bottom", bottom);
  spinnerStart.css("bottom", bottom);
}

export const getUrlParameter = function getUrlParameter(sParam) {
  var sPageURL = window.location.search.substring(1),
    sURLVariables = sPageURL.split("&"),
    sParameterName,
    i;

  for (i = 0; i < sURLVariables.length; i++) {
    sParameterName = sURLVariables[i].split("=");

    if (sParameterName[0] === sParam) {
      return sParameterName[1] === undefined
        ? true
        : decodeURIComponent(sParameterName[1]);
    }
  }
  return false;
};
